import React, { useState, useEffect, useContext, useRef } from 'react';
import { Accordion, Form, Col, Modal } from 'react-bootstrap';
import Editor from '../../image/editor';
import EditorLogo from '../../image/editor-logo';
import Select, { components } from 'react-select';
import { useCart } from '../../../contexts/CartContext';
import Color from '../../../assets/icons/color.svg'
import { Sidebar } from 'primereact/sidebar';
import { CirclePicker } from 'react-color';
import Basket from '../../../assets/icons/basket.svg'
import ArrowDown from '../../../assets/icons/select-arrow-down.svg'
import Check from '../../../assets/icons/check.svg'
import beard from '../../../assets/images/logo-beard.svg'
import Patter1 from '../../../assets/images/design/patterns/1.svg'
import Patter2 from '../../../assets/images/design/patterns/2.svg'
import Patter3 from '../../../assets/images/design/patterns/3.svg'
import Patter4 from '../../../assets/images/design/patterns/4.svg'
import useToastNotification from '../../../hooks/useToastNotification';
import Info from '../../../assets/icons/info.svg';

// Primary patterns
import PrimaryPatter1 from '../../../assets/images/design/patterns/main/1.png'
import PrimaryPatter2 from '../../../assets/images/design/patterns/main/2.png'
import PrimaryPatter3 from '../../../assets/images/design/patterns/main/3.png'
import PrimaryPatter4 from '../../../assets/images/design/patterns/main/4.png'


import ImageDefaultBg from '../../../assets/images/design/image-default-bg.svg'
import LogoDefaultBg from '../../../assets/images/design/logo-default-bg.svg'
import { useNavigate } from 'react-router-dom';

function DesignPage({ onUserDesignCardChange, product,selectedImage}) {
  const navigate = useNavigate();
  // editor 
  // Custom styles to hide unwanted elements
  const customStyles = {
    default: {


      swatches: {
        display: "none",
      },
    },
  };
  const [colorsPicker, setColorsPicker] = useState(['#FFFFFF', '#000000', '#58647A', '#63C6C3', '#B9D546', '#FFF56D', '#FF0000']);

  const prepeardTexts = [
    "آرزوی بهترین هارو برایت دارم",
    "آمدی تا زمینم را آسمان کنی",
    "آیینه ی تمام نمای عشق، روزت مبارک",
    "با آرزوی اقبالی خوش",
    "با آرزوی بهترین موفقیت ها",
    "با تشکر از زحمات شما",
    "با نوید سلامتی و آرزوی تندرستی",
    "بماند به یادگار، به طراوت و به سادگی",
    "پدرم تولدت مبارک",
    "پدرم روزت مبارک",
    "پیوندتان مبارک ",
    "تبریک دست خالی مارا با سخاوت بی حدت بپذیر",
    "تقدیم برای سپاس از زحمات بی دریغ شما",
    "تقدیم به آنی که بهشت زیر پایش جای دارد",
    "تقدیم به زیباترین هدیه خداوند بر روی زمین",
    "تقدیم به مرد تمام روزهای زندگیم",
    "تقدیم به وجود پر مهرت",
    "تولدت مبارک",
    "تویی آن که خیزد از وی همه خرمی و سبزی ",
    "جهان کوچک من از تو زیباست",
    "ثانیه های زندگیت سرشار از شادی",
    "ثانیه ثانیه های زندگیتان سرشار از شادی",
    "دوستت دارم",
    "دیدگانت همیشه شاد",
    "حلول ماه مبارک رمضان مبارک",
    "دیدگانت همیشه شاد",
    "روز پاسدار مبارک ",
    "روز پدر بر شما مبارک باد",
    "روز پرستار مبارک",
    "روز پزشک مبارک",
    "روز جوان مبارک",
    "روز خبرنگار مبارک",
    "روز دانشجو مبارک",
    "روز دختر مبارک",
    "روز زن مبارک",
    "روز کارگر مبارک",
    "روز مادر بر شما مبارک باد",
    "روز مرد مبارک",
    "روز معلم مبارک",
    "عید سعید فطر مبارک",
    "مادرم تولدت مبارک",
    "مادرم روزت مبارک"
  ]
  const [text, setText] = useState('');
  const [color, setColor] = useState('#000');
  const [font, setFont] = useState({
    value: 'IRANSans',
    label: 'ایران سنس'
  });
  const [productId, setProductId] = useState(1);
  const [isAddBasket, setIsAddBasket] = useState(false);
  const [visiblePrepeardTexts, setVisiblePrepeardTexts] = useState(false);
  const [visibleFont, setVisibleFont] = useState(false);
  const [visibleSize, setVisibleSize] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [uniQueId, setUniQueId] = useState('');
  const [uniQueLogoId, setUniQueLogoId] = useState('');
  const [finalImage, setFinalImage] = useState(null);
  const [quantityLogo, setQuantityLogo] = useState(1);
  const [isAddLogoBasket, setIsAddLogoBasket] = useState(false);

  const { showError, showSuccess } = useToastNotification();
  const [fonts, setFonts] = useState([{
    value: 'shabnam-medium',
    label: 'شبنم'
  },
  {
    value: 'IRANSans',
    label: 'ایران سنس'
  },
  {
    value: 'iran-yekan-medium',
    label: 'ایران یکان'
  }

  ]);
  const [size, setSize] = useState('18');
  const [sizes, setSizes] = useState([
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
  ])
  // const getCategory = async () => {
  //   try {
  //     let res = await getCategories()
  //     setCategoryList(res.data.data)
  //   } catch (error) {
  const [image, setImage] = useState((ImageDefaultBg));
  const [logo, setLogo] = useState(null);
  let patterns = [
    { label: "Option 1", value: 1, icon: Patter1, primaryIcon: PrimaryPatter1 },
    { label: "Option 2", value: 2, icon: Patter2, primaryIcon: PrimaryPatter2 },
    { label: "Option 3", value: 3, icon: Patter3, primaryIcon: PrimaryPatter3 },
    { label: "Option 4", value: 4, icon: Patter4, primaryIcon: PrimaryPatter4 },
  ];

  useEffect(() => {
    setTimeout(() => {
      const elements = document.querySelectorAll('.flexbox-fix');

      if (elements.length >= 2) {
        // حذف سومین عنصر
        elements[1].remove();
      }
      // بررسی می‌کنیم آیا سومین عنصر وجود دارد یا نه
      if (elements.length >= 3) {
        // حذف سومین عنصر
        elements[2].remove();
      }
    }, 2000);

  }, [])
  useEffect(() => {
    if (product) {
      setTimeout(() => {
        
        setText(product.cardText || '');
        setSize(product.fontSize || '20');
        setColor(product.fontColor || '#000');
        // setFont({
        //   value: product.font || 'IRANSans',
        //   label: product.fontLabel || 'ایران سنس'
        // });
        // setImage(product.image || ImageDefaultBg);
        // setLogo(product.logo || null);
      }, 1500);
    }
  }, [product]);
  useEffect(() => {
    console.log('text', text)
    if (text == '' || text == undefined) {
      setText(null)
    }
  }, [text])

  useEffect(() => {
    console.log('image', image)
  }, [image])
  const [pattern, setPattern] = useState(patterns[0]);
  const selectImage = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
    }
    let element = document.getElementById('choose-file')
    if (element) {
      element.value = null;
    }
  };
  const resetImage = () => {
    let value = designType;
    if (value === 'picture') {
      setImage(ImageDefaultBg);
    }
    else {
      setImage(LogoDefaultBg);
    }
  };

  const selectLogo = (e) => {
    if (!image) {
      return;
    }
    if (e.target.files[0]) {
      setLogo(e.target.files[0]);
    }
    let element = document.getElementById('choose-logo');
    if (element) {
      element.value = null;
    }
  };
  const resetLogo = () => {
    setLogo(null);
  };


  const generateRandomId = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
  useEffect(() => {
    if (selectedImage) {
        setImage(selectedImage); // تنظیم تصویر از prop
    }
}, [selectedImage]);
  const saveToLocalStorage = (updatedQuantity, uniQue) => {
    setTimeout(() => {
      let settings = localStorage.getItem('settings');
      const newProductData = {
        productId: product.productId,
        imageBase64: finalImage,
        fontSize: typeof size === 'object' && Object.keys(size).length > 0 ? size.label : size,
        font: typeof font === 'object' && Object.keys(font).length > 0 ? font.label : font,
        fontColor: color,
        cardText: text,
      };
      onUserDesignCardChange(newProductData,image);

    }, 1000);


  };
  const [canvasUpdated, setCanvasUpdated] = useState(false);
  useEffect(() => {
    setCanvasUpdated(true);
}, [text, size, font, color,finalImage]);
  useEffect(() => {
    if (canvasUpdated) {
        saveToLocalStorage();
        setCanvasUpdated(false);
    }
}, [canvasUpdated]);
  const changeQuantity = (action) => {
    if (action === 'add') {
      setQuantity(prevQuantity => {
        const updatedQuantity = prevQuantity + 1;
        // saveToLocalStorage(updatedQuantity, uniQueId); // Save with new quantity
        return updatedQuantity;
      });
    }
    if (action === 'minus') {
      if (quantity > 1) {
        setQuantity(prevQuantity => {
          const updatedQuantity = prevQuantity - 1;
          // saveToLocalStorage(updatedQuantity, uniQueId); // Save with updated quantity
          return updatedQuantity;
        });
      }
      //  else {
      //   setIsAddBasket(false);
      //   removeFromCart(uniQueId); // Remove item if quantity is zero
      //   addToCart()
      // }
    }
  };

  const handleAddToBasket = () => {
    const uniqueId = generateRandomId(); // Generate random ID for the item
    setUniQueId(uniqueId)
    setModalShow(false);
    setIsAddBasket(true);
    saveToLocalStorage(quantity > 0 ? quantity : 1, uniqueId); // Save product to cart with quantity
    setQuantity(quantity > 0 ? quantity : 1);
  };

 

  const [ModalShow, setModalShow] = React.useState(false);
  const closeModal = () => {
    setModalShow(false);
  };
  const showModal = () => {

    setModalShow(true);
  };
  const [ModalLogoShow, setModalLogoShow] = React.useState(false);
  const closeLogoModal = () => {
    setModalLogoShow(false);
  };
  const showLogoModal = () => {
    console.log('image', image)
    setModalLogoShow(true);
  };
  const handleAddLogoToBasket = () => {
    const uniqueId = generateRandomId(); // Generate random ID for the item
    setModalLogoShow(false);
    setUniQueLogoId(uniqueId)
    setIsAddLogoBasket(true);
    saveToLocalStorage(quantityLogo > 0 ? quantityLogo : 1, uniqueId); // ذخیره کارت با مقدار
    setQuantityLogo(quantityLogo > 0 ? quantityLogo : 1);
  };
  // Helper function to remove product from cart
  const removeFromCart = (uniqueId) => {
    const cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];

    // Filter out the specific item that matches all properties
    const updatedCart = cartItems.filter(item =>
      item.id !== uniqueId
      // !(
      //   item.productId === productId &&
      //   item.font === (typeof font === 'object' && Object.keys(font).length > 0 ? font.id : font) &&
      //   item.fontSize === size &&
      //   item.fontColor === color &&
      //   item.cardText === text &&
      //   item.price === JSON.parse(localStorage.getItem('settings'))?.customCardPrice
      // )
    );

    // Update localStorage with the filtered cart
    sessionStorage.setItem('cartItems', JSON.stringify(updatedCart));
  };

  const handleImageUpdate = (imageData) => {
    setFinalImage(imageData); // ذخیره‌ی عکس نهایی در استیت
  };

  const [isDefultImages, setIsDefultImages] = useState(null)
  const handleImageDefult = (imageData) => {

    console.log(imageData)// ذخیره‌ی عکس نهایی در استیت
    if (imageData) {
      setImage(imageData.src)

    }
  };


  const [uploadedImage, setUploadedImage] = useState(null);
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedImage(file);
    }
  };




  // Design
  const [designType, setDesignType] = useState('picture');
  const changeDesignType = (e) => {
    let value = e.target.id;
    setDesignType(value);
    if (value === 'picture') {
      setImage(ImageDefaultBg);
    }
    else {
      setImage(LogoDefaultBg);
    }
  };

  
  const [displayPicker, setDisplayPicker] = useState(false);

  const handleIconClick = () => {
    setDisplayPicker(!displayPicker); // نمایش یا مخفی کردن انتخابگر
    setTimeout(() => {
      const whiteCircle = document.querySelector('[title="#FFFFFF"]');

      if (whiteCircle) {
        whiteCircle.style.border = '2px solid #000'; // اضافه کردن بوردر مشکی
        whiteCircle.style.borderRadius = '50%'; // گرد کردن بوردر
      }
    }, 0);
  };


  const handleChangeComplete = (color) => {
    setColor(color.hex); // به‌روزرسانی رنگ انتخاب‌شده
  };
  const newDesignCard = () => {
    setIsAddBasket(false)
  }
  const newDesignLogoCard = () => {
    setIsAddLogoBasket(false)
  }

  const options = prepeardTexts.map((text) => ({ value: text, label: text }));
  const sizeOptions = sizes.map((text) => ({ value: text, label: text }));

  const CustomDropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.8527 9.64582C18.0484 9.84073 18.0489 10.1573 17.854 10.3529L12.389 15.8374C12.1741 16.0531 11.8248 16.0531 11.6098 15.8374L6.14484 10.3529C5.94993 10.1573 5.95049 9.84073 6.1461 9.64582C6.34171 9.4509 6.65829 9.45147 6.85321 9.64708L11.9994 14.8117L17.1456 9.64708C17.3406 9.45147 17.6571 9.4509 17.8527 9.64582Z" fill="#668CFF" />
        </svg>

      </components.DropdownIndicator>
    );
  };
  const customSelectStyles = {
    option: (provided) => ({
      ...provided,
      fontSize: "14px", // Customize font size here
      padding: "10px",  // Optional: Adjust padding for a better look
    }),
    control: (provided) => ({
      ...provided,
      fontSize: "14px", // Change font size for the selected option box
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "14px", // Change font size for the currently selected value
    }),
  };


  const handleSelectChange = (selected) => {
    setText(selected ? selected.label : ""); // تنظیم مقدار `text` با انتخاب یا حذف مقدار
  };
  const handleSize = (selected) => {
    setSize(selected ? selected : ""); // تنظیم مقدار `text` با انتخاب یا حذف مقدار
  };
  const handleTextChange = (e) => {
    const newValue = e.target.value;
    setText(newValue);

    // اگر مقدار خالی شد، انتخاب `Select` نیز خالی می‌شود

  };

  function convertToPersianNumbers(input) {
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return input.replace(/\d/g, (digit) => persianDigits[digit]);
  }
  return (
    <div className=" border-white rounded-2xl design-body	 !bg-[#FFFFFF4F] py-4 px-4   pb-0">






      {designType === 'picture' ?
        // Picture
        <div className="flex  justify-between flex-col-dir design-card">
          <div className='flex-1'>
            <div className='d-flex align-items-end'>
              <img className='web' src={beard} alt="" style={{ marginTop: '-0.5em', marginRight: '0' }} />
              <h4 className='title-design font-bold text-[#001966]' style={{ marginRight: '0' }}>همین الان کارت هدیه‌ای که دوست داری را طراحی کن ...</h4>
            </div>
            <div className="my-3 font-bold mt-5 d-flex align-items-center">
              <Form.Check
                inline
                label="طراحی با تصویر"
                name="group1"
                type='radio'
                id='picture'
                checked={designType === 'picture'}
                onChange={changeDesignType}
              />
              <Form.Check
                inline
                label="طراحی با الگو"
                name="group1"
                type='radio'
                id='logo'
                checked={designType === 'logo'}
                onChange={changeDesignType}
              />
            </div>
            <Form >
              <div className='row mb-4 mt-3'>
                <Form.Group className="col-12 col-md-5 ">

                  <div style={{ height: '44px', border: '1px solid #E5ECFF' }} className={`flex justify-between items-center p-2 rounded-lg text-sm cursor-pointer   ${isAddBasket ? ' bg-[#e9ecef]' : 'bg-[#fff]'} `}
                    onClick={() => { document.getElementById('choose-file')?.click() }}>
                    <div>بارگذاری تصویر</div>
                    <div><img src={require('../../../assets/icons/upload.svg').default} alt="" /></div>
                  </div>
                  <Form.Control disabled={isAddBasket} placeholder='بارگذاری تصویر' type="file" accept='image/*' id='choose-file' onChange={selectImage} className='d-none' />
                </Form.Group>
              </div>


              <div className=" row">
                <Form.Group className="mb-3 col-12 col-md-5">
                  <Form.Label>متن کارت</Form.Label>
                  <Form.Control
                    value={text}
                    onChange={handleTextChange}
                    type="text"
                    disabled={isAddBasket}
                  />
                </Form.Group>
                <Form.Group className="mb-4 col-10 col-md-5 sample-text">
                  <Form.Label>متن های آماده</Form.Label>
                  {/* Select for mobile view */}
                  <div className='input-icon mobile'>
                    <Form.Control value={text}
                      onClick={(e) => {
                        e.preventDefault(); // جلوگیری از باز شدن لیست
                        setVisiblePrepeardTexts(true); // نمایش Sidebar
                      }}
                      disabled={isAddBasket}
                      readOnly />
                    <img src={ArrowDown} alt="" />
                  </div>
                  <Sidebar
                    header="متن های آماده"
                    visible={visiblePrepeardTexts}
                    position="bottom"
                    onHide={() => setVisiblePrepeardTexts(false)}
                  >
                    <div className="prepared-text-options">
                      {prepeardTexts.map((item, index) => (
                        <div
                          key={index}
                          className={`prepared-text-item ${text === item ? 'selected' : ''}`}
                          onClick={() => {
                            setText(item);
                            setVisiblePrepeardTexts(false); // Close sidebar on selection
                          }}
                          style={{
                            padding: '10px',
                            borderBottom: '1px solid #eee',
                            cursor: 'pointer',
                          }}
                        >
                          {item}
                        </div>
                      ))}
                    </div>
                  </Sidebar>
                  <Select
                    options={options}
                    value={text ? options.find((option) => option.label === text) : null} // سینک با `text`
                    onChange={handleSelectChange}
                    styles={customSelectStyles}
                    placeholder="انتخاب کنید"
                    className="web"
                    isDisabled={isAddBasket}
                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                  />

                  {/* Select for web view */}
                  {/* <Form.Select disabled={isAddBasket} size='sm' className="web" value={text} onChange={(e) => setText(e.target.value)} >
                    <option value='' selected hidden>انتخاب کنید</option>
                    {prepeardTexts.map((text, index) => (
                      <option key={index} value={text}>{text}</option>
                    ))}
                  </Form.Select> */}
                </Form.Group>


                <Form.Group className='mb-4 col-2 col-md-2' style={{ position: 'relative' }}>
                  <Form.Label ></Form.Label>

                  <div className='mt-2'>
                    {/* Hidden input */}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'start',
                        gap: '10px',
                        justifyContent: 'start',
                        position: 'relative'
                      }}
                    >
                      {/* آیکون برای باز کردن SketchPicker */}
                      <div
                        className={`${isAddBasket ? ' bg-[#e9ecef]' : 'bg-[#fff]'} input-icons justify-content-center`}

                        style={{ height: '44px', width: '44px', cursor: 'pointer' }}
                        onClick={handleIconClick}
                      >
                        <img
                          src={Color}
                          alt="color-preview"
                        />
                      </div>

                      {/* نمایش SketchPicker */}
                      {displayPicker && (
                        <div className='color-picker' style={{ position: 'absolute', zIndex: 2 }}>
                          <CirclePicker
                            styles={customStyles}
                            color={color}
                            width={280}
                            circleSize={24}
                            colors={colorsPicker}
                            onChangeComplete={handleChangeComplete}
                          />
                        </div>
                      )}
                      {displayPicker && (
                        <div
                          style={{
                            position: 'fixed',
                            top: '3em',
                            left: 0,
                            right: 0,
                            bottom: 0,
                            zIndex: 1,
                          }}
                          onClick={() => setDisplayPicker(false)} // بستن انتخابگر با کلیک خارج از آن
                        />
                      )}
                    </div>

                  </div>
                </Form.Group>
              </div>


              <div className="row ">
                <Form.Group className="mb-3 col-12 col-md-5">
                  <Form.Label>فونت</Form.Label>
                  {/* Select for mobile view */}
                  <div className="input-icon mobile">
                    <Form.Control
                      value={font.label} // Use font (id) for control value
                      onClick={(e) => {
                        e.preventDefault(); // Prevent opening list
                        setVisibleFont(true); // Show Sidebar
                      }}
                      disabled={isAddBasket}
                      readOnly
                    />
                    <img src={ArrowDown} alt="" />
                  </div>
                  <Sidebar
                    header="فونت"
                    visible={visibleFont}
                    position="bottom"
                    onHide={() => setVisibleFont(false)}
                  >
                    <div className="prepared-text-options">
                      {fonts.map((item, index) => (
                        <div
                          key={index}
                          className={`prepared-text-item ${font === item.value ? 'selected' : ''}`}
                          onClick={() => {
                            setFont(item); // Update font id
                            setVisibleFont(false); // Close sidebar on selection
                          }}
                          style={{
                            padding: '10px',
                            borderBottom: '1px solid #eee',
                            cursor: 'pointer',
                          }}
                        >
                          {item.label}
                        </div>
                      ))}
                    </div>
                  </Sidebar>
                  <Select
                    options={fonts}
                    onChange={(selected) => setFont(selected)}
                    styles={customSelectStyles}
                    placeholder="انتخاب کنید"
                    className='web font-zIndex'
                    style={{ zIndex: '100000' }}
                    isDisabled={isAddBasket}
                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                  />
                  {/* <Form.Select disabled={isAddBasket} className='web' value={font} onChange={e => { setFont(e.target.value) }}>
                    {fonts.map(item =>
                      <option value={item.id} >{item.name}</option>
                    )}
                  </Form.Select> */}
                </Form.Group>
                <Form.Group className="mb-3 col-12 col-md-5 ">
                  <Form.Label>سایز</Form.Label>

                  <div className='input-icon mobile'>
                    <Form.Control value={size}
                      className='number'
                      disabled={isAddBasket}
                      onClick={(e) => {
                        e.preventDefault(); // جلوگیری از باز شدن لیست
                        setVisibleSize(true); // نمایش Sidebar
                      }}
                      readOnly />
                    <img src={ArrowDown} alt="" />
                  </div>
                  <Sidebar
                    header="سایز"
                    visible={visibleSize}
                    position="bottom"
                    onHide={() => setVisibleSize(false)}
                  >
                    <div className="prepared-text-options">
                      {sizes.map((item, index) => (
                        <div
                          key={index}
                          className={`prepared-text-item ${size === item ? 'selected' : ''} number`}
                          onClick={() => {
                            setSize(item);
                            setVisibleSize(false); // Close sidebar on selection
                          }}
                          style={{
                            padding: '10px',
                            borderBottom: '1px solid #eee',
                            cursor: 'pointer',
                          }}
                        >
                          {item}
                        </div>
                      ))}
                    </div>
                  </Sidebar>
                  <Select
                    options={sizeOptions}
                    onChange={(selected) => setSize(selected.label)}
                    styles={customSelectStyles}
                    isDisabled={isAddBasket}
                    placeholder="انتخاب کنید"
                    className='web number'
                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                  />

                  {/* <Form.Select className='web number' value={size} onChange={e => { setSize(e.target.value) }} disabled={isAddBasket}>
                    {sizes.map(item =>
                      <option value={item} className='number'>{item}</option>
                    )}
                  </Form.Select> */}
                </Form.Group>
              </div>

             

            </Form>
          </div>
          <div className='marginTop'>
            <div className='aspect-auto'>
              {
                !image ?

                  <div className='flex justify-center items-center'>
                    <img src={require('../../../assets/images/design.svg').default} className='w-[30em] cursor-pointer' alt=""
                      onClick={() => { document.getElementById('choose-file')?.click() }} />
                  </div>
                  :
                  <div className='mt-2 text-center'>
                    <Editor
                      image={image}
                      isDefult={image === '/static/media/image-default-bg.d0215f8539c9ad54697a4e6fa801e734.svg' ? true : false}
                      text={text}
                      color={color}
                      font={font.value}
                      size={size}
                      imageUpdate={handleImageUpdate}
                      isDefultImage={handleImageDefult}
                      resetImage={resetImage}
                      className="custom-editor-image"
                    />
                  </div>
              }
            </div>
          </div>
        </div>
        :
        // Logo
        <div className="flex justify-between flex-col-dir design-card">
          <div className='flex-1'>
            <div className='d-flex align-items-end'>
              <img className='web' src={beard} alt="" style={{ marginTop: '-0.5em', marginRight: '0' }} />
              <h4 className='title-design font-bold text-[#001966]' style={{ marginRight: '0' }}>همین الان کارت هدیه‌ای که دوست داری را طراحی کن ...</h4>
            </div>
            <div className="my-3 font-bold mt-5 d-flex align-items-center">
              <Form.Check
                inline
                label="طراحی با تصویر"
                name="group1"
                type='radio'
                id='picture'
                checked={designType === 'picture'}
                onChange={changeDesignType}
              />
              <Form.Check
                inline
                label="طراحی با الگو"
                name="group1"
                type='radio'
                id='logo'
                checked={designType === 'logo'}
                onChange={changeDesignType}
              />
            </div>
            <Form>
              <div className='row'>
                <Form.Group className="mb-3 col-12 col-md-5">
                  <div style={{ height: '44px', border: '1px solid #E5ECFF' }} className={`flex justify-between items-center p-2 rounded-lg text-sm cursor-pointer  ${isAddLogoBasket ? ' bg-[#e9ecef]' : 'bg-[#fff]'} `} onClick={() => { document.getElementById('choose-file')?.click() }}>
                    <div>بارگذاری تصویر</div>
                    <div><img src={require('../../../assets/icons/upload.svg').default} alt="" /></div>
                  </div>
                  <Form.Control disabled={isAddLogoBasket} placeholder='بارگذاری تصویر' type="file" accept='image/*' id='choose-file' onChange={selectImage} className='d-none' />
                </Form.Group>

              </div>

              <div className="row">

                <Form.Group className="mb-3 col-12 col-md-5">
                  <div style={{ height: '44px', border: '1px solid #E5ECFF', marginTop: '2em' }} className={` flex justify-between items-center p-2  rounded-lg text-sm cursor-pointer  ${isAddLogoBasket ? ' bg-[#e9ecef]' : 'bg-[#fff]'}`}
                    onClick={() => { !!image && document.getElementById('choose-logo')?.click() }}>
                    <div>بارگذاری الگو</div>
                    <div><img src={require('../../../assets/icons/upload.svg').default} alt="" /></div>
                  </div>
                  <Form.Control disabled={isAddLogoBasket} placeholder='بارگذاری الگو' type="file" accept='image/*' id='choose-logo' onChange={selectLogo} className='d-none' />
                </Form.Group>

                <Form.Group className="mb-3 col-12 col-md-5">
                  <Form.Label>الگو</Form.Label>
                  <Select isDisabled={isAddLogoBasket} isSearchable={false} style={{ height: '44px', border: '1px solid #E5ECFF' }} options={patterns} value={pattern} defaultValue={patterns[0]} formatOptionLabel={(option) => {
                    return (
                      <div style={{ display: "flex" }}>
                        <img src={option.icon} alt="" />
                      </div>
                    );
                  }}
                    onChange={item => setPattern(item)}
                  />
                  {/* <Form.Select value={text} onChange={(e) => setText(e.target.value)}>
                          <option value="I love you">
                            <img src={require('../../assets/images/design/patterns/1.svg').default} alt="" />
                          </option>
                          <option value="آرزوی بهترین هارو برایت دارم">آرزوی بهترین هارو برایت دارم</option>
                          <option value="آمدی تا زمینم را آسمان کنی">آمدی تا زمینم را آسمان کنی</option>
                          <option value="آیینه ی تمام نمای عشق، روزت مبارک">آیینه ی تمام نمای عشق، روزت مبارک</option>
                        </Form.Select> */}
                </Form.Group>
              </div>



              <div className=" row">
                <Form.Group className="mb-3 col-12 col-md-5">
                  <Form.Label>متن کارت</Form.Label>

                  <Form.Control
                    value={text}
                    onChange={handleTextChange}
                    type="text"
                    disabled={isAddLogoBasket}
                  />
                </Form.Group>
                <Form.Group className="mb-4 col-10 col-md-5 sample-text">
                  <Form.Label>متن های آماده</Form.Label>
                  {/* Select for mobile view */}

                  <div className='input-icon mobile'>
                    <Form.Control value={text ? text : ''}
                      onClick={(e) => {
                        e.preventDefault(); // جلوگیری از باز شدن لیست
                        setVisiblePrepeardTexts(true); // نمایش Sidebar
                      }}
                      disabled={isAddLogoBasket}
                      readOnly />
                    <img src={ArrowDown} alt="" />
                  </div>
                  <Sidebar
                    header="متن های آماده"
                    visible={visiblePrepeardTexts}
                    position="bottom"
                    onHide={() => setVisiblePrepeardTexts(false)}
                  >
                    <div className="prepared-text-options">
                      {prepeardTexts.map((item, index) => (
                        <div
                          key={index}
                          className={`prepared-text-item ${text === item ? 'selected' : ''}`}
                          onClick={() => {
                            setText(item);
                            setVisiblePrepeardTexts(false); // Close sidebar on selection
                          }}
                          style={{
                            padding: '10px',
                            borderBottom: '1px solid #eee',
                            cursor: 'pointer',
                          }}
                        >
                          {item}
                        </div>
                      ))}
                    </div>
                  </Sidebar>
                  <Select
                    options={options}
                    value={text ? options.find((option) => option.label === text) : null} // سینک با `text`
                    onChange={handleSelectChange}
                    styles={customSelectStyles}
                    placeholder="انتخاب کنید"
                    className="web"
                    isDisabled={isAddLogoBasket}
                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                  />

                  {/* Select for web view */}
                  {/* <Form.Select disabled={isAddBasket} size='sm' className="web" value={text} onChange={(e) => setText(e.target.value)} >
                    <option value='' selected hidden>انتخاب کنید</option>
                    {prepeardTexts.map((text, index) => (
                      <option key={index} value={text}>{text}</option>
                    ))}
                  </Form.Select> */}
                </Form.Group>


                <Form.Group className=' col-2 col-md-2 color-font' style={{ position: 'relative' }}>
                  <Form.Label ></Form.Label>

                  <div className='mt-2'>
                    {/* Hidden input */}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'start',
                        gap: '10px',
                        justifyContent: 'start',
                        position: 'relative'
                      }}
                    >
                      {/* آیکون برای باز کردن SketchPicker */}
                      <div
                        className={`${isAddLogoBasket ? ' bg-[#e9ecef]' : 'bg-[#fff]'} input-icons justify-content-center`}

                        style={{ height: '44px', width: '44px', cursor: 'pointer' }}
                        onClick={handleIconClick}
                      >
                        <img
                          src={Color}
                          alt="color-preview"
                        />
                      </div>

                      {/* نمایش SketchPicker */}
                      {displayPicker && (
                        <div className='color-picker' style={{ position: 'absolute', zIndex: 2 }}>
                          <CirclePicker
                            styles={customStyles}
                            color={color}
                            width={280}
                            circleSize={24}
                            colors={colorsPicker}
                            onChangeComplete={handleChangeComplete}
                          />
                        </div>
                      )}
                      {displayPicker && (
                        <div
                          style={{
                            position: 'fixed',
                            top: '3em',
                            left: 0,
                            right: 0,
                            bottom: 0,
                            zIndex: 1,
                          }}
                          onClick={() => setDisplayPicker(false)} // بستن انتخابگر با کلیک خارج از آن
                        />
                      )}
                    </div>

                  </div>
                </Form.Group>
              </div>


              <div className="row ">
                <Form.Group className="mb-3 col-12 col-md-5">
                  <Form.Label>فونت</Form.Label>
                  {/* Select for mobile view */}
                  <div className="input-icon mobile">
                    <Form.Control
                      value={font.label} // Use font (id) for control value
                      onClick={(e) => {
                        e.preventDefault(); // Prevent opening list
                        setVisibleFont(true); // Show Sidebar
                      }}
                      disabled={isAddBasket}
                      readOnly
                    />
                    <img src={ArrowDown} alt="" />
                  </div>
                  <Sidebar
                    header="فونت"
                    visible={visibleFont}
                    position="bottom"
                    onHide={() => setVisibleFont(false)}
                  >
                    <div className="prepared-text-options">
                      {fonts.map((item, index) => (
                        <div
                          key={index}
                          className={`prepared-text-item ${font === item.value ? 'selected' : ''}`}
                          onClick={() => {
                            setFont(item); // Update font id
                            setVisibleFont(false); // Close sidebar on selection
                          }}
                          style={{
                            padding: '10px',
                            borderBottom: '1px solid #eee',
                            cursor: 'pointer',
                          }}
                        >
                          {item.label}
                        </div>
                      ))}
                    </div>
                  </Sidebar>
                  <Select
                    options={fonts}
                    onChange={(selected) => setFont(selected)}
                    styles={customSelectStyles}
                    placeholder="انتخاب کنید"
                    className='web font-zIndex'
                    isDisabled={isAddLogoBasket}
                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                  />
                  {/* <Form.Select disabled={isAddBasket} className='web' value={font} onChange={e => { setFont(e.target.value) }}>
                    {fonts.map(item =>
                      <option value={item.id} >{item.name}</option>
                    )}
                  </Form.Select> */}
                </Form.Group>
                <Form.Group className="mb-3 col-12 col-md-5 ">
                  <Form.Label>سایز</Form.Label>

                  <div className='input-icon mobile'>
                    <Form.Control value={size ? size : ''}
                      className='number'
                      disabled={isAddBasket}
                      onClick={(e) => {
                        e.preventDefault(); // جلوگیری از باز شدن لیست
                        setVisibleSize(true); // نمایش Sidebar
                      }}
                      readOnly />
                    <img src={ArrowDown} alt="" />
                  </div>
                  <Sidebar
                    header="سایز"
                    visible={visibleSize}
                    position="bottom"
                    onHide={() => setVisibleSize(false)}
                  >
                    <div className="prepared-text-options">
                      {sizes.map((item, index) => (
                        <div
                          key={index}
                          className={`prepared-text-item ${size === item ? 'selected' : ''} number`}
                          onClick={() => {
                            setSize(item);
                            setVisibleSize(false); // Close sidebar on selection
                          }}
                          style={{
                            padding: '10px',
                            borderBottom: '1px solid #eee',
                            cursor: 'pointer',
                          }}
                        >
                          {item}
                        </div>
                      ))}
                    </div>
                  </Sidebar>
                  <Select
                    options={sizeOptions}
                    onChange={(selected) => setSize(selected.label)}
                    styles={customSelectStyles}
                    placeholder="انتخاب کنید"
                    className='web'
                    isDisabled={isAddLogoBasket}
                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                  />
                  {/* <Form.Select className='web number' value={size} onChange={e => { setSize(e.target.value) }} disabled={isAddBasket}>
                    {sizes.map(item =>
                      <option value={item} className='number'>{item}</option>
                    )}
                  </Form.Select> */}
                </Form.Group>
              </div>
            </Form>
          </div>
          <div className='marginTop'>
            <div className='aspect-auto'>
              {
                !image ?

                  <div className='flex justify-center items-center'>
                    <img src={require('../../../assets/images/designing-card-logo.svg').default} className='w-[30em] cursor-pointer' alt=""
                      onClick={() => { document.getElementById('choose-file')?.click() }} />
                  </div>
                  :
                  <div className='mt-2 text-center'>
                    <EditorLogo
                      pattern={pattern}
                      isDefult={image === '/static/media/logo-default-bg.6108b2b5477071480fc6f9c65cc58d5f.svg' ? true : false}
                      isDefultImage={handleImageDefult}
                      image={image}
                      text={text}
                      color={color}
                      font={font.value}
                      size={size}
                      imageUpdate={handleImageUpdate}
                      resetImage={resetImage}
                      logo={logo}
                      resetLogo={resetLogo}
                      className="custom-editor-image"
                    />

                  </div>
              }
            </div>
          </div>
         
        </div>
      }
      <Modal
        show={ModalLogoShow}
        onHide={() => setModalLogoShow(false)}
        centered
      >
        <Modal.Body className='!p-5'>
          <div className="flex gap-1 border-b-[#668CFF] border-b-[1px] pb-3">
            <img src={require('../../../assets/icons/danger.svg').default} alt="" />
            <div className="font-bold text-blue">خروج</div>
          </div>
          <div className='font-bold mt-4'>شما در حال سفارش کارت هدیه دلخواه با طرح پیش فرض هستید، آیا از انجام این کار مطمئن هستید؟</div>
          <div className="flex gap-2 mt-4">
            <button className='btn btn-outline-primary !border-1 !border-blue flex-1' onClick={closeLogoModal}>انصراف</button>
            <button className='btn btn-primary flex-[2]' onClick={() => handleAddLogoToBasket()}>تایید</button>
          </div>
        </Modal.Body>
      </Modal>


      <Modal
        show={ModalShow}
        onHide={() => setModalShow(false)}
        centered
      >
        <Modal.Body className='!p-5'>
          <div className="flex gap-1 border-b-[#668CFF] border-b-[1px] pb-3">
            <img src={require('../../../assets/icons/danger.svg').default} alt="" />
            <div className="font-bold text-blue">خروج</div>
          </div>
          <div className='font-bold mt-4'>شما در حال سفارش کارت هدیه دلخواه با طرح پیش فرض هستید، آیا از انجام این کار مطمئن هستید؟</div>
          <div className="flex gap-2 mt-4">
            <button className='btn btn-outline-primary !border-1 !border-blue flex-1' onClick={closeModal}>انصراف</button>
            <button className='btn btn-primary flex-[2]' onClick={() => handleAddToBasket()}>تایید</button>
          </div>
        </Modal.Body>
      </Modal>
    </div >
  );
}

export default DesignPage;
